import Icon from "meta/ui2/icon";
import clsx from "clsx";
import { Box, CircularProgress, IconButton, withStyles } from "@material-ui/core";
import { LineColor } from "meta/utils/colors";
const Actions = withStyles({
    root: {
        display: "flex",
        gap: "4px",
        "& > *": {
            cursor: "pointer",
            padding: "2px 4px",
            transition: "background 350ms ease-out",
            borderRadius: 4,
            "&:hover": { background: "#bbb" },
        },
    },
})(Box);
const Content = withStyles({
    root: {
        flex: 1,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        gap: "12px",
        paddingInline: 8,
        marginBlock: 2,
        lineHeight: "16px",
        borderRight: "1px solid transparent",
        "&.divider": { borderRightColor: "#878787" },
    },
})(Box);
const StyledTab = withStyles({
    root: {
        borderRadius: 12,
        minWidth: 120,
        background: "rgba(200, 200, 200, 0.5)",
        transition: "background 200ms ease-out",
        userSelect: "none",
        display: "flex",
        whiteSpace: "nowrap",
        position: "relative",
        cursor: "auto !important",
        border: "2px solid transparent",
        borderBottomColor: LineColor,
        borderInlineWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        "&:hover": { background: "rgba(200, 200, 200, 0.3)" },
        "&.active": {
            background: "white",
            borderColor: LineColor,
            borderInlineWidth: 2,
            borderBottomColor: "transparent",
            borderTopLeftRadius: 8,
            borderTopRightRadius: 8,
            "& > *": { borderWidth: 0 },
        },
        "&:focus-visible": {
            boxShadow: "0px 0px 5px 3px #45baff",
        },
    },
})(Box);
const Tab = ({ active, dockable, onDockClick, undockable, onUndockClick, closeable, onCloseClick, onRefreshNotificationsClick, onRefreshPendingClick, isNotificationCenter, isPendingTab, modified, children, innerRef, divider, onClick, notificationsRefreshing, ...props }) => {
    const handleMouseUp = (event) => {
        if (closeable && event.button === 1) {
            onCloseClick && onCloseClick(event);
            event.stopPropagation();
        }
    };
    const handleKeyPressed = (event) => {
        if (event.code === "Enter") {
            onClick();
        }
    };
    return (<StyledTab component="li" className={`${clsx({ active })}`} onKeyPress={handleKeyPressed} onMouseUp={handleMouseUp} onClick={onClick} {...props} 
    // @ts-ignore
    ref={innerRef}>
      <Content className={clsx({ divider })}>
        <span style={{ marginBlock: 2 }}>{children}</span>
        {modified && "*"}
        <Actions>
          {undockable && (<IconButton onClick={onUndockClick}>
              <Icon name="angle-double-left" data-identification="tabs-undock-action" onClick={onUndockClick} className="fa-xs"/>
            </IconButton>)}
          {dockable && (<IconButton onClick={onDockClick}>
              <Icon name="columns" className="tab-docking-toggle" data-identification="tabs-dock-action" onClick={onDockClick}/>
            </IconButton>)}
          {isNotificationCenter && (<IconButton onClick={onRefreshNotificationsClick}>
              {notificationsRefreshing ? (<CircularProgress size={12}/>) : (<Icon name="refresh" className="tab-close" data-identification="refresh-notification-action"/>)}
            </IconButton>)}
          {isPendingTab && (<IconButton onClick={onRefreshPendingClick}>
              <Icon name="refresh" className="tab-close" data-identification="refresh-pending-action"/>
            </IconButton>)}
          {closeable && (<IconButton onClick={onCloseClick}>
              <Icon name="times" className="tab-close" data-identification="tabs-close-action"/>
            </IconButton>)}
        </Actions>
      </Content>
    </StyledTab>);
};
export default Tab;
